<template>
    <div>
        <layoutHeader @toggleSideBarHide="(e)=>toggleSideBarHide=e"></layoutHeader>
        <el-container class="container">
            <!-- <NavBar :menuShow="menu_show"></NavBar> -->
            <layoutSidebar :menuShow="menu_show" style="z-index: 99" v-if="toggleSideBarHide"></layoutSidebar>
            <el-container :style="$route.path=='/rygl/rygl/home/index'?'background-color:#1E2637':''"
                          class="elContainerBox">
                <!-- <Breadcrumb :toggleSideBarHide="toggleSideBarHide" @menuShowChange="(e)=>menu_show=e"></Breadcrumb> -->
                <div class="w-100 bg-white flex align-center"
                     style="position: relative;"
                     v-if="$route.path!='/rygl/rygl/home/index'">
                    <img :style="!menu_show ?'transform: rotate(180deg);':''" @click="menu_show = !menu_show" alt=""
                         class="ml-1"
                         height="30" src="../assets/mbx.png" style="cursor: pointer;"
                         v-if="toggleSideBarHide">
                    <TabView style="z-index: 2000;background:white;overflow: auto;"></TabView>
                </div>
                <el-main style="background-color: #F5F6FA" :style="{'--padding':$route.meta.pageParam&&$route.meta.pageParam.pageType=='map'?'0px':'16px'}">
                    <keep-alive :include="visitedViewList">
                        <router-view :key="key"/>
                    </keep-alive>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  // import NavBar from "@/layout/components/NavBar";
  import layoutSidebar from '@/layout/components/LayoutSidebar/index.vue'
  import ThemeSelect from '@/layout/components/ThemeSelect'
  import layoutHeader from '@/layout/components/LayoutHeader/LayoutHeader.vue'
  import Breadcrumb from '@/components/Breadcrumb'
  import TabView from '@/components/TabView'
  //
  export default {
    name: 'layout',
    components: {
      // NavBar,
      layoutSidebar,
      ThemeSelect,
      layoutHeader,
      Breadcrumb,
      TabView
    },
    data() {
      return {
        toggleSideBarHide: false,//侧边栏显示隐藏
        menu_show: true,
      }
    },
    watch: {
      '$route.meta.pageParam': {
        handler(newVal, oldVal) {
          // console.log(newVal,'newVal')
          //解析pageParam参数
          if (newVal && newVal.length) {
            const pageParam = newVal.split(',')
            this.$route.meta.pageParam = pageParam.reduce(function (prev, curr) {
              let keyValue = curr.split(':') // 将当前字符串按冒号分割为键和值
              let key = keyValue[0].trim().replace(/"/g, '') // 去除空格和双引号，作为属性名
              let value = keyValue[1].trim().replace(/"/g, '') // 去除空格和双引号，作为属性值
              prev[key] = value // 将属性和值添加到对象
              return prev
            }, {})
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {},
    computed: {
      ...mapGetters([
        'headerTheme'
      ]),
      noCachedViewList() {
        return this.$store.state.tagsView.noCachedViewList
      },
      visitedViewList() {
        return this.$store.state.tagsView.visitedViewList
      },
      key() {
        let fullPath = this.$route.fullPath
        if (fullPath === '/index') {
          this.$router.push({
            path: '/home'
          })
        }
        // console.log('route-fullpath', this.$route)
        return fullPath
      }
    }
  }
</script>

<style lang='scss' scoped>
    .container {
        height: calc(100% - 70px);
    }

    /deep/ .el-main {
      // padding: 0; // 涉及地图的页面会有留白(优化：配置路由设置pageType:map 页面不会留白了)
      // padding: 16px 16px 24px 16px;
      padding: var(--padding);
    }

    .el-main::-webkit-scrollbar {
        display: none;
    }

    .elContainerBox {
        padding: 0px 0px 0px;
        display: flex;
        flex-flow: column;
    }

    .turnMenu {
        transform: rotate(180deg);
    }

    .main-back{
        background-image: url('../assets/img/gnjsz.png');
        background-repeat: no-repeat;
        background-position: center;
    }
</style>
